<template>
    <div class="py-2 container-fluid">
        <div class="row">
            <div class="mx-auto col-10">
                <div class="card">
                    <div class="card-header">
                        <h6 class="mb-0">{{ id == 'new' ? 'Novo Acesso de Implantador' : 'Editar Acesso de Implantador'
                            }}</h6>
                        <p class="mb-0 text-sm">Criar/Editar acesso de implantador à empresa</p>
                    </div>
                    <div class="card-body">
                        <form role="form" @submit.prevent="onSubmit">
                            <div class="row mb-3">
                                <div class="col-md-4">
                                    <label>Tipo de Acesso</label>
                                    <select class="form-control" v-model="v$.acessoEmpresa.tipoAcesso.$model">
                                        <option :value="null">Selecione um tipo de acesso...</option>
                                        <option :value="1">Implantação</option>
                                        <option :value="2">Upsell</option>
                                        <option :value="3">Downsell</option>
                                    </select>
                                    <div class="input-errors" v-for="(error, index) of v$.acessoEmpresa.tipoAcesso.$errors"
                                        :key="index">
                                        <div class="text-danger text-xs">{{ error.$message }}</div>
                                    </div>
                                </div>                                
                                <div class="col-md-4">
                                    <label>Data de Início</label>
                                    <InputDateTime v-model="v$.acessoEmpresa.dataInicio.$model" type="date" />
                                    <div class="input-errors"
                                        v-for="(error, index) of v$.acessoEmpresa.dataInicio.$errors" :key="index">
                                        <div class="text-danger text-xs">{{ error.$message }}</div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Data de Fim</label>
                                    <InputDateTime v-model="v$.acessoEmpresa.dataFim.$model" type="date" />
                                    <div class="input-errors" v-for="(error, index) of v$.acessoEmpresa.dataFim.$errors"
                                        :key="index">
                                        <div class="text-danger text-xs">{{ error.$message }}</div>
                                    </div>
                                </div>                               

                            </div>

                            <div class="row mb-3">
                                <div class="col-md-4">
                                    <label>Implantador</label>
                                    <select class="form-control" v-model="v$.acessoEmpresa.implantador.$model">
                                        <option :value="null">Selecione um implantador...</option>
                                        <option v-for="implantador in implantadores" :key="implantador.id"
                                            :value="implantador">
                                            {{ implantador.nome }}
                                        </option>
                                    </select>
                                    <div class="input-errors"
                                        v-for="(error, index) of v$.acessoEmpresa.implantador.$errors" :key="index">
                                        <div class="text-danger text-xs">{{ error.$message }}</div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <label>Empresa</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control font-weight-bold"
                                            :value="empresaSelecionada" readonly />
                                        <argon-button color="info" size="xs" variant="gradient" data-bs-toggle="modal"
                                            data-bs-target="#modal-selecionar-empresa">
                                            Selecionar
                                            <i class="fas fa-search"></i>
                                        </argon-button>
                                    </div>
                                    <div class="input-errors"
                                        v-for="(error, index) of v$.acessoEmpresa.empresaId.$errors" :key="index">
                                        <div class="text-danger text-xs">{{ error.$message }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">

                            </div>
                            <div class="d-flex justify-content-between">
                                <router-link :to="{ name: 'Implantadores Acesso Empresas' }">
                                    <argon-button type="button" color="dark" class="my-4 mb-2">
                                        Voltar
                                    </argon-button>
                                </router-link>
                                <div>
                                    <argon-button v-if="id !== 'new' && !acessoEmpresa.dataRemocaoAcesso" type="button"
                                        color="warning" class="my-4 mb-2 me-2" @click="removeAccess">
                                        Remover Acesso
                                    </argon-button>
                                    <argon-button type="submit" color="success" variant="gradient" class="my-4 mb-2">
                                        SALVAR
                                    </argon-button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Usando o componente de modal para seleção de empresas -->
    <empresa-seletor-modal :empresas-ja-selecionadas="empresasSelecionadas" :search="search"
        @update:search="search = $event" @adicionar-empresa="adicionarEmpresa" />
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import ArgonButton from "@/components/ArgonButton.vue";
import { successToast, errorToast } from '@/utils/alerts';
import { formatDate } from '@/utils/date';
import api from '@/services/api'
import InputDateTime from '@/components/InputDateTime.vue';
import EmpresaSeletorModal from '@/views/pages/GrupoEmpresa/components/EmpresaSeletorModal.vue';
import * as moment from 'moment';

export default {
    name: "ImplantadorAcessoEmpresa",
    components: {
        ArgonButton,
        InputDateTime,
        EmpresaSeletorModal,
    },
    created() {
        this.id = this.$route.params.id;
        this.fetchImplantadores();
        this.fetchUsuarios();

        if (this.id == 'new') {
            return;
        }

        this.fetchData();
    },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    data() {
        return {
            id: null,
            implantadores: [],
            usuarios: [],
            acessoEmpresa: {
                id: null,
                implantador: null,
                tipoAcesso: 2,
                empresaId: '',
                usuarioEmpresaId: '',
                dataInicio: moment().toDate(),
                dataFim: moment().toDate(),
                dataRemocaoAcesso: '',
                usuario: null,
                empresa: null,
            },
            search: '',
            empresasSelecionadas: [],
        }
    },
    validations() {
        return {
            acessoEmpresa: {
                implantador: {
                    required: helpers.withMessage('Implantador é obrigatório', required),
                },
                tipoAcesso: {
                    required: helpers.withMessage('Tipo de acesso é obrigatório', required),
                },
                empresaId: {
                    required: helpers.withMessage('Empresa é obrigatória', required),
                },
                dataInicio: {
                    required: helpers.withMessage('Data de início é obrigatória', required),
                },
                dataFim: {
                    required: helpers.withMessage('Data de fim é obrigatória', required),
                },
            },
        }
    },
    methods: {
        fetchData() {
            const { id } = this;

            api.get(`/implantadores-acesso-empresas/${id}`)
                .then(({ data }) => {
                    this.acessoEmpresa = {
                        ...data,
                        dataInicio: this.formatDateTimeForInput(data.dataInicio),
                        dataFim: this.formatDateTimeForInput(data.dataFim),
                        dataRemocaoAcesso: data.dataRemocaoAcesso ? this.formatDateTimeForInput(data.dataRemocaoAcesso) : '',
                    };
                })
                .catch(e => console.log(e));
        },
        fetchImplantadores() {
            api.get('/implantadores')
                .then(({ data }) => {
                    this.implantadores = data.filter(implantador => implantador.ativo);
                })
                .catch(e => console.log(e));
        },
        fetchUsuarios() {
            api.get('/usuario')
                .then(({ data }) => {
                    this.usuarios = data;
                })
                .catch(e => console.log(e));
        },
        formatDateTimeForInput(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toISOString().slice(0, 16); // YYYY-MM-DDTHH:MM
        },
        formatDate(dateString) {
            return formatDate(dateString);
        },
        async removeAccess() {
            if (!confirm('Tem certeza que deseja remover este acesso?')) {
                return;
            }

            try {
                await api.patch(`/implantadores-acesso-empresas/${this.id}/remove-access`);
                successToast('Acesso removido com sucesso.');
                this.$router.push({ name: 'Implantadores Acesso Empresas' });
            } catch (e) {
                console.log(e);
                const { data } = e;
                const message = data ? data.message : e.message;
                errorToast(message);
            }
        },
        adicionarEmpresa(empresa) {
            this.empresasSelecionadas = [
                empresa.id
            ];
            this.acessoEmpresa.empresa = empresa;
            this.acessoEmpresa.empresaId = empresa.id;
        },
        async onSubmit() {
            const isFormValid = await this.v$.$validate();

            if (!isFormValid) {
                return;
            }

            // Validar se data fim é posterior à data início
            const dataInicio = moment(this.acessoEmpresa.dataInicio);
            const dataFim = moment(this.acessoEmpresa.dataFim);

            if (dataFim.isBefore(dataInicio, 'date')) {
                errorToast('Data de fim deve ser posterior à data de início');
                return;
            }

            try {
                const payload = {
                    ...this.acessoEmpresa,
                }

                await (this.id == 'new' ?
                    api.post('/implantadores-acesso-empresas', payload) :
                    api.patch(`/implantadores-acesso-empresas/${this.id}`, payload));

                successToast('Acesso salvo com sucesso.');

                this.$router.push({ name: 'Implantadores Acesso Empresas' });

            } catch (e) {
                console.log(e);
                const { data } = e;
                const message = data ? data.message : e.message;
                errorToast(message)
            }
        }

    },
    computed: {
        empresaSelecionada() {
            if (!this.acessoEmpresa.empresa) {
                return 'Selecione uma empresa...';
            }

            let descricao = '';

            const { empresa } = this.acessoEmpresa;

            const { cidade } = empresa;

            descricao = `${empresa.id} - ${empresa.nomeFantasia}`;


            if (cidade) {
                descricao += ` / ${cidade.descricao}-${cidade.uf.uf}`;
            }

            return descricao.toUpperCase();
        }
    }
};
</script>